const SectionHome = Class(
	/**
	 * @lends {SectionHome#}
	 */
	{
		_countersAnimated: false,

		draw() {
			this.apiCallDelayed = new DR.ApiCall();
			this.apiCallDelayed.onLoad = this.apiCallDelayedRe;
			this.node = mkE({
				tag: 'div',
				id: 'SectionHome',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container fade',
						els: [
							{
								tag: 'div',
								className: 'hero__top',
								els: [
									{
										tag: 'h1',
										innerHTML: t('b2b.home.hero.h1')
									},
									{
										tag: 'p',
										text: t('b2b.home.hero.p')
									}
								]
							},
							{
								tag: 'div',
								className: 'hero__btn',
								els: [
									{
										tag: 'a',
										className: 'button button-pink',
										href: D.url('/contact-us?ref=home'),
										text: t('b2b.home.hero.btn')
									}
								]
							},
							{
								tag: 'div',
								className: 'hero__counters',
								els: [
									{
										tag: 'div',
										els: [
											{
												tag: 'strong',
												text: t('b2b.home.hero.counter.adventurers')
											},
											this._countAdventurersNode = mkE({
												tag: 'div',
												className: 'h1',
												text: 0
											})
										]
									},
									{
										tag: 'div',
										els: [
											{
												tag: 'strong',
												text: t('b2b.home.hero.counter.games')
											},
											this._countGamesNode = mkE({
												tag: 'div',
												className: 'h1',
												text: 0
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'hero__bottom',
								els: [
									{
										tag: 'a',
										className: 'h3 about',
										href: D.url('/about-us'),
										innerHTML: t('b2b.home.hero.bottom.about')
									},
									{
										tag: 'a',
										className: 'h3 events',
										href: D.url('/events'),
										innerHTML: t('b2b.home.hero.bottom.events')
									}
								]
							}
						]
					},
					new T.TrustedBy({
						className: 'mb-5 fade',
						apiCall: this.apiCallDelayed
					}),
					this._caseStudies = new T.CaseStudies('corporate', {
						apiCall: this.apiCallDelayed,
						pseudoType: 'b2b.home',
						hasSubtitle: true,
						className: 'mb-4 fade'
					}),
					T.SocialIcons({
						className: 'container mb-5 home__socials fade',
						title: t('b2b.home.follow_us.title'),
						text: '',
						socials: ['tk', 'fb', 'in', 'ig']
					}),
					this._testimonials = new T.Quotes('corporate', {
						apiCall: this.apiCallDelayed,
						className: 'mb-5 fade'
					}),
					{
						tag: 'div',
						className: 'mb-5 home__newsletter fade',
						els: [
							{
								tag: 'div',
								className: 'container',
								els: [
									{
										tag: 'div',
										className: 'h2',
										text: t('b2b.home.newsletter-opt-in.title')
									}
								]
							},
							{
								tag: 'div',
								className: 'container-wide',
								els: [
									new T.NewsletterSignUp()
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-5 home__steps fade',
						els: [
							{
								tag: 'h2',
								className: 'mb-4',
								text: t('b2b.steps.h2')
							},
							{
								tag: 'div',
								className: 'steps',
								els: [
									{
										tag: 'h3',
										className: 'mb-4',
										text: t('b2b.steps.h3')
									},
									{
										tag: 'div',
										className: 'list',
										els: [
											{
												tag: 'ul',
												els: (function() {
													let els = [];
													let list = t('b2b.steps.list').split('\n');
													for (let i = 0; i < list.length; i++) {
														els.push({
															tag: 'li',
															text: list[i]
														});
													}
													return els;
												})()
											}
										]
									}
								]
							}
						]
					},
					new T.FAQ({
						title: D.Lang.get('corporate.faq.title'),
						prefix: 'corporate.faq',
						className: 'mb-5 container fade',
					})
				]
			}).append(this.layout.ct());

			this._mStats = new DR.web.Stats();
			this._mStats.onLoad = this._mStatsRe;
			this.apiCallDelayed.addMethod(this._mStats);

			this.ready();
		},

		_mStatsRe() {
			if (this._onScrollAnimateCounters) {
				this._onScrollAnimateCounters();
			}
		},

		onShow() {
			this.apiCallDelayed.call();
			this.fadeOnShow();
		},

		apiCallDelayedRe() {
			if (this._testimonials) {
				this._testimonials.onShow();
			}
			if (this._caseStudies) {
				this._caseStudies.onShow();
			}
		},

		onLeave() {
			if (this._testimonials) {
				this._testimonials.onLeave();
			}
			if (this._caseStudies) {
				this._caseStudies.onLeave();
			}
		},

		onScroll() {
			this.fadeOnScroll();
			if (this._onScrollAnimateCounters) {
				this._onScrollAnimateCounters();
			}
		},

		_onScrollAnimateCounters() {
			if (this._mStats.re && D.inScreenAny(this._countAdventurersNode)) {
				this._onScrollAnimateCounters = null;
				T.Counter(this._countAdventurersNode, 0, this._mStats.re.adventurers, 3000);
				T.Counter(this._countGamesNode, 0, this._mStats.re.games, 3000);
			}
		}

	},
	Section
);

